import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
    RefferedUsers,
    InfluencerData,
  } from "../../redux/actions/InfluencerAction";
const Crm = () => {
    const history = useHistory();
    const user = JSON.parse(localStorage.getItem("CRM"));
    useEffect(() => {
        if (!user) {
            history.push("/crm/login");
        }
        InfluencerData();
    }, [user]);
    return (
        <div className="mt- pt-5 pb-5">
            <h1 className="mt- pt-5 text-center">Dasboard</h1>
            <div className="ml-5 mr-5">
                <table class="table">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Phone No</th>
                            <th scope="col">Time Stamp</th>
                            <th scope="col">T&C acceptance</th>
                            <th scope="col">Promo, Emails & Messages</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">1</th>
                            <td>Mark</td>
                            <td>Otto@gmail.com</td>
                            <td>123456</td>
                            <td>10/8/2021, 12:36:43 PM</td>
                            <td>Yes</td>
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck1" checked />
                                    <label class="custom-control-label" for="customCheck1"></label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2</th>
                            <td>Mark</td>
                            <td>Otto@gmail.com</td>
                            <td>123456</td>
                            <td>10/8/2021, 12:36:43 PM</td>
                            <td>Yes</td>
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck1" checked />
                                    <label class="custom-control-label" for="customCheck1"></label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">3</th>
                            <td>Mark</td>
                            <td>Otto@gmail.com</td>
                            <td>123456</td>
                            <td>10/8/2021, 12:36:43 PM</td>
                            <td>Yes</td>
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck1" checked />
                                    <label class="custom-control-label" for="customCheck1"></label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>


            </div>
        </div>
    )
}

export default Crm;